/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Fab,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Autocomplete,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useEffect, useState } from "react";
import { getAnteojoArreglo } from "../../services/EnvioAnteojoArregloService";
import { getCacheData } from "../../services/CacheService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialAnteojoArreglo = {
  anteojoArregloOk: false,
  bandejaCodigoDisabled: false,
  dataDisabled: true,
  bandeja: "",
  codigoAnteojoArreglo: "",
  tipoAnteojoArreglo: "",
  idGcAnteojoArreglo: "",
  codigoGC: "",
  clienteNombreApellido: "",
  clienteEmail: "",
  clienteTelefonos: "",
  descripcionAreaOrigen: "",
  idAreaDestino: "",
  descripcionAreaDestino: "",
  descripcionCortaAreaDestino: "",
  usuario: "",
  observaciones: "",
  monturaNuevoCliente: "",
  monturaNuevoDescripcion: "",
  monturaNuevoObservaciones: "",
  monturaClienteDescripcion: "",
  monturaClienteObservaciones: "",
  tieneCristalOD: false,
  cristalOD: "",
  tieneCristalOI: false,
  cristalOI: "",
  notas: "",
};

const nameItemText = "Anteojo/Arreglo";
let actionCrudDescription = "";
//
// ###########################################################################
//
const EnvioAnteojoArregloDialog = ({
  actionCrud,
  anteojoArregloItem,
  onSave,
  onClose,
  setMessage,
  setShowMessage,
}) => {
  const [anteojoArreglo, setAnteojoArreglo] = useState(initialAnteojoArreglo);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [areas, setAreas] = useState([]);
  const [valueACArea, setvalueACArea] = useState({
    id: "",
    descripcion: "",
    descripcion_corta: "",
  });
  const [inputvalueACArea, setInputvalueACArea] = useState("");
  //
  // ################################################################################
  //
  useEffect(() => {

    loadAreas();
    if (actionCrud === "new") {
      actionCrudDescription = "Ingresar";
    } else if (actionCrud === "delete") {
      actionCrudDescription = "Quitar";
      setAnteojoArreglo({
        ...anteojoArregloItem,
        anteojoArregloOk: true,
        bandejaCodigoDisabled: true,
        dataDisabled: true,
      });
    }
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (anteojoArreglo.bandeja.length > 0) {
      setAnteojoArreglo({
        ...anteojoArreglo,
        codigoAnteojoArreglo: "",
      });
    }
  }, [anteojoArreglo.bandeja]);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (anteojoArreglo.codigoAnteojoArreglo.length > 0) {
      setAnteojoArreglo({
        ...anteojoArreglo,
        bandeja: "",
      });
    }
  }, [anteojoArreglo.codigoAnteojoArreglo]);
  //
  // ################################################################################
  //
  const loadAreas = async () => {
    const response = await getCacheData('area');
    if (response.ok) {
      const _response = response.data.data.filter(area => area.actividad === "punto-de-venta");
      setAreas(_response);
    } else {
      setMessage({
        severity: response.messageSeverity,
        messageText: response.messageText,
      });
      setShowMessage(true);
      return;
    }
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setAnteojoArreglo({
      ...anteojoArreglo,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const loadAnteojoArreglo = async () => {

    if (!anteojoArreglo.bandeja && !anteojoArreglo.codigoAnteojoArreglo) {
      setMessage({
        severity: "error",
        messageText:
          "Debes ingresar el número de la bandeja o el código del Anteojo/Arreglo a enviar a la Sucursal",
      });
      setShowMessage(true);
      return;
    }

    let _object = {
      bandeja: anteojoArreglo.bandeja,
      codigoAnteojoArreglo: anteojoArreglo.codigoAnteojoArreglo,
    };

    setIsDoingSomething(true);
    const response = await getAnteojoArreglo(_object);
    setIsDoingSomething(false);

    if (response.ok) {
      // recibo los datos del backend
      // actualizo los datos del anteojo/arreglo

      let _response = response.data.data;
      let _tipoAnteojoArreglo = "anteojo" in _response ? "Anteojo" : "Arreglo";
      let _anteojoArreglo =
        _tipoAnteojoArreglo === "Anteojo" ? _response.anteojo : _response.arreglo;
      let _monturaNuevoCliente =
        _anteojoArreglo.montura_nuevo_cliente.accion === "agrega-arm-asol-nuevo"
          ? "nuevo"
          : "cliente";
      let _tieneCristalOD = Object.keys(_anteojoArreglo.cristal_block_od).length != 0;
      let _tieneCristalOI = Object.keys(_anteojoArreglo.cristal_block_oi).length != 0;

      setAnteojoArreglo({
        ...anteojoArreglo,
        anteojoArregloOk: true,
        bandejaCodigoDisabled: true,
        dataDisabled: false,
        tipoAnteojoArreglo: _tipoAnteojoArreglo,
        idGcAnteojoArreglo:
          _tipoAnteojoArreglo === "Anteojo"
            ? _anteojoArreglo.id_gc_anteojo
            : _anteojoArreglo.id_gc_arreglo,
        codigoGC: _anteojoArreglo.codigo_gc,
        codigoAnteojoArreglo:
          _tipoAnteojoArreglo === "Anteojo"
            ? _anteojoArreglo.codigo_gc_anteojo
            : _anteojoArreglo.codigo_gc_arreglo,
        clienteNombreApellido:
          _anteojoArreglo.nombre_cliente + " " + _anteojoArreglo.apellido_cliente,
        clienteEmail: _anteojoArreglo.email_cliente,
        clienteTelefonos: (
          _anteojoArreglo.telefono_movil_cliente +
          " " +
          _anteojoArreglo.telefono_cliente
        ).trim(),
        descripcionAreaOrigen: _anteojoArreglo.descripcion_area,
        descripcionCortaAreaOrigen: _anteojoArreglo.descripcion_corta_area,
        idAreaDestino: _anteojoArreglo.id_area,
        descripcionAreaDestino: _anteojoArreglo.descripcion_area_entrega,
        descripcionCortaAreaDestino: _anteojoArreglo.descripcion_corta_area_entrega,
        usuario: _anteojoArreglo.usuario,
        observaciones:
          _tipoAnteojoArreglo === "Anteojo"
            ? _anteojoArreglo.observaciones_gc_anteojo
            : _anteojoArreglo.observaciones_gc_arreglo,
        monturaNuevoCliente: _monturaNuevoCliente,
        monturaNuevoDescripcion:
          _monturaNuevoCliente === "nuevo"
            ? _anteojoArreglo.montura_nuevo_cliente.codigo +
            " - " +
            _anteojoArreglo.montura_nuevo_cliente.descripcion +
            " - " +
            _anteojoArreglo.montura_nuevo_cliente.descripcion_ar_as_marca +
            " - " +
            _anteojoArreglo.montura_nuevo_cliente.modelo
            : "",
        monturaNuevoObservaciones:
          _monturaNuevoCliente === "nuevo"
            ? _anteojoArreglo.montura_nuevo_cliente.observaciones
            : "",
        monturaClienteDescripcion: _monturaNuevoCliente === "cliente" ? "MONTURA DE CLIENTE" : "",
        monturaClienteObservaciones:
          _monturaNuevoCliente === "cliente"
            ? _anteojoArreglo.montura_nuevo_cliente.observaciones
            : "",
        tieneCristalOD: _tieneCristalOD,
        cristalOD: _tieneCristalOD
          ? _anteojoArreglo.cristal_block_od.codigo +
          " - " +
          _anteojoArreglo.cristal_block_od.descripcion +
          " - " +
          _anteojoArreglo.cristal_block_od.modelo
          : "",
        cristalODObservaciones: _tieneCristalOD
          ? _anteojoArreglo.cristal_block_od.observaciones
          : "",
        tieneCristalOI: _tieneCristalOI,
        cristalOI: _tieneCristalOI
          ? _anteojoArreglo.cristal_block_oi.codigo +
          " - " +
          _anteojoArreglo.cristal_block_oi.descripcion +
          " - " +
          _anteojoArreglo.cristal_block_oi.modelo
          : "",
        cristalOIObservaciones: _tieneCristalOI
          ? _anteojoArreglo.cristal_block_oi.observaciones
          : "",
      });
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    setvalueACArea({
      id: anteojoArreglo.idAreaDestino,
      descripcion: anteojoArreglo.descripcionAreaDestino || "",
      descripcion_corta: anteojoArreglo.descripcionCortaAreaDestino || "",
    });
  }, [anteojoArreglo.idAreaDestino]);
  //
  // ################################################################################
  //
  const cleanAnteojoArreglo = () => {
    setAnteojoArreglo(initialAnteojoArreglo);
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (!anteojoArreglo.anteojoArregloOk) {
      setMessage({
        severity: "error",
        messageText:
          "Debes ingresar y confirmar el número de la bandeja o el código del Anteojo/Arreglo a enviar",
      });
      setShowMessage(true);
      return;
    }

    if (!anteojoArreglo.idAreaDestino) {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar la sucursal de destino del Anteojo/Arreglo a enviar",
      });
      setShowMessage(true);
      return;
    }

    let _anteojoArreglo = {
      bandeja: anteojoArreglo.bandeja,
      codigoAnteojoArreglo: anteojoArreglo.codigoAnteojoArreglo,
      codigoGC: anteojoArreglo.codigoGC,
      tipoAnteojoArreglo: anteojoArreglo.tipoAnteojoArreglo,
      idGcAnteojoArreglo: anteojoArreglo.idGcAnteojoArreglo,
      idAreaDestino: anteojoArreglo.idAreaDestino,
      descripcionAreaDestino: anteojoArreglo.descripcionAreaDestino,
      descripcionCortaAreaDestino: anteojoArreglo.descripcionCortaAreaDestino,
      clienteNombreApellido: anteojoArreglo.clienteNombreApellido,
      notas: anteojoArreglo.notas,
    };
    onSave(_anteojoArreglo, actionCrud);

    if (actionCrud === "new") {
      cleanAnteojoArreglo();
    } else {
      onClose();
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="xl"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrudDescription} {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 1, mb: 1 }}>
            <Box sx={{ p: 0, m: 1 }}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={2} lg={2}>
                  <TextField
                    id="bandeja"
                    label="Número de bandeja"
                    size="small"
                    sx={{ width: "100%" }}
                    type="number"
                    inputProps={{
                      autoComplete: "off",
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      style: { textAlign: "left" },
                    }}
                    name="bandeja"
                    value={anteojoArreglo.bandeja}
                    variant="outlined"
                    onChange={handleChange}
                    disabled={anteojoArreglo.bandejaCodigoDisabled}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={2} lg={2}>
                  <TextField
                    id="codigoAnteojoArreglo"
                    label="Código de Anteojo/Arreglo"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{
                      autoComplete: "off",
                    }}
                    name="codigoAnteojoArreglo"
                    value={anteojoArreglo.codigoAnteojoArreglo}
                    variant="outlined"
                    onChange={handleChange}
                    disabled={anteojoArreglo.bandejaCodigoDisabled}
                  />
                </Grid>

                {actionCrud === "new" && (
                  <Grid item xs={6}>
                    <Tooltip title="buscar">
                      <Fab
                        sx={{ ml: 1, mr: 1 }}
                        color="primary"
                        aria-label="add"
                        size="small"
                        onClick={loadAnteojoArreglo}
                        disabled={anteojoArreglo.bandejaCodigoDisabled}
                      >
                        <SearchIcon />
                      </Fab>
                    </Tooltip>
                    <Tooltip title="limpiar">
                      <Fab
                        sx={{ ml: 1, mr: 1 }}
                        color="outlined"
                        aria-label="add"
                        size="small"
                        onClick={cleanAnteojoArreglo}
                      >
                        <CleaningServicesIcon />
                      </Fab>
                    </Tooltip>
                  </Grid>
                )}
              </Grid>
            </Box>

            <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 1, mb: 1 }}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {/* <Typography variant="h6" gutterBottom>
                    {anteojoArreglo.tipoAnteojoArreglo}
                  </Typography> */}
                  <Typography variant="h6" gutterBottom>
                    Datos de Gestión de Atención y de Cliente
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={2} lg={2}>
                  <TextField
                    id="codigoGC"
                    label="Código de Gestión de Atención"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                    name="codigoGC"
                    value={anteojoArreglo.codigoGC}
                    variant="outlined"
                  // disabled={true}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={2} lg={2}>
                  <TextField
                    id="codigoAnteojoArreglo"
                    label="Código de Anteojo/Arreglo"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                    name="codigoAnteojoArreglo"
                    value={anteojoArreglo.codigoAnteojoArreglo}
                    variant="outlined"
                  // disabled={true}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <TextField
                    id="descripcionAreaOrigen"
                    label="Sucursal Origen"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                    name="descripcionAreaOrigen"
                    value={anteojoArreglo.descripcionAreaOrigen}
                    variant="outlined"
                  // disabled={true}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <TextField
                    id="usuario"
                    label="Vendedor"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                    name="usuario"
                    value={anteojoArreglo.usuario}
                    variant="outlined"
                  // disabled={true}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <TextField
                    id="clienteNombreApellido"
                    label="Cliente"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                    name="clienteNombreApellido"
                    value={anteojoArreglo.clienteNombreApellido}
                    variant="outlined"
                  // disabled={true}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <TextField
                    id="clienteEmail"
                    label="Email"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                    name="clienteEmail"
                    value={anteojoArreglo.clienteEmail}
                    variant="outlined"
                  // disabled={true}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <TextField
                    id="clienteTelefonos"
                    label="Teléfonos"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                    name="clienteTelefonos"
                    value={anteojoArreglo.clienteTelefonos}
                    variant="outlined"
                  // disabled={true}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 1, mb: 1 }}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography variant="h6" gutterBottom>
                    Armazón / Anteojo de Sol
                  </Typography>
                </Grid>

                {anteojoArreglo.monturaNuevoCliente === "nuevo" && (
                  <>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <TextField
                        id="monturaNuevoDescripcion"
                        label="Código - Descripción - Marca - Modelo"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="monturaNuevoDescripcion"
                        value={anteojoArreglo.monturaNuevoDescripcion}
                        variant="outlined"
                      // disabled={true}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <TextField
                        id="monturaNuevoObservaciones"
                        label="Observaciones"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="monturaNuevoObservaciones"
                        value={anteojoArreglo.monturaNuevoObservaciones}
                        variant="outlined"
                      // disabled={true}
                      />
                    </Grid>
                  </>
                )}

                {anteojoArreglo.monturaNuevoCliente === "cliente" && (
                  <>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <TextField
                        id="monturaClienteDescripcion"
                        label="Descripcion montura del Cliente"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="monturaClienteDescripcion"
                        value={anteojoArreglo.monturaClienteDescripcion}
                        variant="outlined"
                      // disabled={true}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <TextField
                        id="monturaClienteObservaciones"
                        label="Observaciones"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="monturaClienteObservaciones"
                        value={anteojoArreglo.monturaClienteObservaciones}
                        variant="outlined"
                      // disabled={true}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </Box>

            <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 1, mb: 1 }}>
              <Grid container spacing={1}>
                {anteojoArreglo.tieneCristalOD && (
                  <>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography variant="h6" gutterBottom>
                        Cristal OD
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <TextField
                        id="cristalOD"
                        label="Cristal OD"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="cristalOD"
                        value={anteojoArreglo.cristalOD}
                        variant="outlined"
                      // disabled={true}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <TextField
                        id="cristalODObservaciones"
                        label="Observaciones"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="cristalODObservaciones"
                        value={anteojoArreglo.cristalODObservaciones}
                        variant="outlined"
                      // disabled={true}
                      />
                    </Grid>
                  </>
                )}

                {anteojoArreglo.tieneCristalOI && (
                  <>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography variant="h6" gutterBottom>
                        Cristal OI
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <TextField
                        id="cristalOI"
                        label="Cristal OI"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="cristalOI"
                        value={anteojoArreglo.cristalOI}
                        variant="outlined"
                      // disabled={true}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <TextField
                        id="cristalOIObservaciones"
                        label="Observaciones"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="cristalOIObservaciones"
                        value={anteojoArreglo.cristalOIObservaciones}
                        variant="outlined"
                      // disabled={true}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </Box>

            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Autocomplete
                  id="id-area-entrega"
                  size="small"
                  width="50%"
                  value={
                    valueACArea && valueACArea.id ? valueACArea : null
                  }
                  onChange={(event, newValue) => {
                    setvalueACArea(newValue);
                    setAnteojoArreglo({
                      ...anteojoArreglo,
                      idAreaDestino: newValue ? newValue.id : "",
                      descripcionAreaDestino: newValue ? newValue.descripcion : "",
                      descripcionCortaAreaDestino: newValue ? newValue.descripcion_corta : "",
                    });
                  }}
                  inputValue={inputvalueACArea}
                  onInputChange={(event, newInputValue) => {
                    setInputvalueACArea(newInputValue);
                  }}
                  options={areas}
                  getOptionLabel={(option) => option.descripcion || ""}
                  renderInput={(params) => <TextField {...params} label="Área de Destino" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disabled={anteojoArreglo.dataDisabled}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="notas"
                  label="Notas"
                  variant="outlined"
                  size="small"
                  name="notas"
                  value={anteojoArreglo.notas}
                  onChange={handleChange}
                  disabled={anteojoArreglo.dataDisabled}
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ textAlign: "right", mt: 2 }}>
            {actionCrud !== "view" && (
              <Button
                sx={{ mr: 1 }}
                variant="contained"
                onClick={handleSave}
                startIcon={actionCrud === "delete" ? <RemoveCircleOutlineIcon /> : <SaveIcon />}
              // color={actionCrud === "delete" ? "error" : "primary"}
              >
                {actionCrud === "delete" ? "Quitar" : "Guardar"}
              </Button>
            )}
            <Button sx={{ mr: 2 }}
              variant="outlined"
              onClick={handleCloseDialog}>
              {actionCrudDescription === "Ver" ? "Cerrar" : "Cancelar"}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />

    </>
  );
};
export default EnvioAnteojoArregloDialog;